import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { useDocTitle } from '../components/CustomHook';

const Blog = () => {
    useDocTitle('Atlantis AI - Blog');

    return (
        <>
            <NavBar />

            <div className="mt-24 px-6 lg:px-24 py-16 bg-white">
            <h1 className="text-4xl font-bold text-center text-sky-600 mb-12">Atlantis AI Blog</h1>

            <div className="grid md:grid-cols-2 gap-12">
                {[...Array(4)].map((_, i) => (
                    <div key={i} className="bg-gray-50 p-8 rounded-xl shadow hover:shadow-xl transition duration-300">
                        <h2 className="text-2xl font-bold text-sky-700 mb-4">LLM-Generated Insight {i + 1}</h2>
                        <p className="text-gray-700 mb-4">
                            Stay up to date with industry trends and best practices in software, AI, and digital transformation. Atlantis AI shares regular insights, tips, and updates to help businesses thrive in a tech-driven world.
                        </p>
                        <p className="text-gray-600 mb-6">
                            This placeholder article generated by a language model dives into how artificial intelligence is reshaping industries such as finance, healthcare, and education. Read more about automation trends and how to position your business for success.
                        </p>
                        <Link to="/blogs/blog1" className="text-sky-600 font-semibold hover:underline">Read More →</Link>
                    </div>
                ))}
            </div>
        </div>

            <Footer />
        </>
    );
};

export default Blog;
